import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseEntityService } from "../rest-common.service";
import { NotificationService } from "src/app/notification.service";

@Injectable({
  providedIn: "root",
})
export class TdspPixelService extends BaseEntityService {
  constructor(public http: HttpClient, public toastr: NotificationService) {
    super();
  }

  public resource_url = `${this.BASE_TDSP_URL}/pixel/`;

  getEventTypes(params = {}) {
    let url = this.buildUrl(`${this.resource_url}event-types/`, "", params);
    return this.get(url);
  }

  getPixelTag(params: any) {
    let url = this.buildUrl(`${this.resource_url}tag/`, "", params);
    return this.get(url);
  }

  //Universal Pixel Tag
  getBulkPixelTags(params : any) {
    let url = this.buildUrl(`${this.resource_url}tag/`, "", params);
    return this.get(url);
  }
}
